import { Avatar, Box, Button, FormControl, Grid, MenuItem, Select, TextField, Typography } from "@mui/material"
import { TEXT_TITLE_COLOR } from "../../constants/colors"
import { useTranslation } from "react-i18next"
import { convertGenderToString } from "../../utils/convertGender"
import { GenderEnum } from "../../enums/genderEnum"
import ConfirmDialog from "../../components/ConfirmDialog"
import useAdminDetailController from "./controller"

const AdminDetailView = () => {
    const controller = useAdminDetailController()
    const { t } = useTranslation('global')

    return (
        <Box>
            <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight="bold">{t("Admin profile")}</Typography>
            <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={6} md={3}>
                    <Box
                        sx={{
                            p: 8,
                            boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            borderRadius: '10px'
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <label htmlFor="image-input-admin">
                                <Avatar
                                    src={controller.imageToShow}
                                    alt=""
                                    style={{ cursor: 'pointer', width: 150, height: 150, objectFit: 'contain' }}
                                />
                            </label>
                            <input
                                type="file"
                                id="image-input-admin"
                                onClick={(e: any) => {
                                    e.target.value = '';
                                }}
                                onChange={controller.handleSelectedImage}
                                style={{ display: 'none' }}
                            />
                        </Box>
                        <Box mt={2}>
                            <Typography textAlign="center">Allowed *.jpeg, *.jpg, *.png</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={10} md={8}>
                    <Box
                        sx={{
                            p: 4,
                            boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            borderRadius: '10px'
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t("admin_page.Full Name")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin="normal"
                                    inputRef={controller.fullName}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t("admin_page.Phone")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin="normal"
                                    inputRef={controller.phone}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t("admin_page.Email")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin='normal'
                                    inputRef={controller.email}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t("admin_page.Date of Birth")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin='normal'
                                    type='date'
                                    inputRef={controller.dateOfBirth}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t("admin_page.Province")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin='normal'
                                    inputRef={controller.province}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t("admin_page.City")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin='normal'
                                    inputRef={controller.city}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t("admin_page.Village")}</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    margin='normal'
                                    inputRef={controller.village}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t("admin_page.Gender")}</Typography>
                                <FormControl fullWidth margin='normal'>
                                    <Select value={controller.selectedGender} onChange={controller.handleSelectedGender}>
                                        {
                                            Object.values(GenderEnum).map((gender: GenderEnum) => (
                                                <MenuItem key={gender} value={gender}>
                                                    {convertGenderToString(gender)}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t("admin_page.User Name")}</Typography>
                                <TextField
                                    fullWidth
                                    disabled
                                    margin='normal'
                                    value={controller.auth?.username}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography>{t('admin_page.Role')}</Typography>
                                <TextField disabled fullWidth margin="normal" value={controller.auth?.role?.name} />
                            </Grid>
                        </Grid>
                        <Box mt={3} sx={{ display: 'flex', gap: 1, justifyContent: 'end' }}>
                            <Button
                                onClick={(e) => controller.handleOpenConfirmForm(e)}
                                variant="contained"
                                color='secondary'
                                sx={{ textTransform: 'none', width: 100, color: '#fff' }}
                            >
                                {t("Save")}
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <ConfirmDialog
                open={controller.openConfirm}
                loading={controller.loadingConfirmForm}
                title={t("admin_page.Do you want to update this profile")}
                onCancel={controller.handleCloseConfirmForm}
                onConfirm={() => controller.handleSubmit()}
            />
        </Box>
    )
}
export default AdminDetailView